export const TZKT_EXPLORER_URL = 'https://tzkt.io';
export const TEZOS_NODES_URL = 'https://www.tezos-nodes.com/baker';
export const QUIPUSWAP = 'https://quipuswap.com/swap';
export const MADFISH = 'https://www.madfish.solutions/';
export const QUIPUSWAP_LIQUIDITY = 'https://quipuswap.com/liquidity/add/tez-';
export const QUIPUSWAP_REMOVE_LIQUIDITY = 'https://quipuswap.com/invest/remove-liquidity';

export const TEMPLEWALLET_IMG = 'https://img.templewallet.com/insecure/fill/50/50/ce/0/plain';
export const CLOUDFLARE_IPFS = 'https://cloudflare-ipfs.com/ipfs';
export const IPFS = 'ipfs';
export const IPFS_IO = 'https://ipfs.io/ipfs/';

export const MOBILE_WIDTH = 560;
export const TABLET_WIDTH = 970;
export const SMALL_SCREEN = 1368;
export const MEDIUM_SCREEN = 1444;

export const DEFAULT_DECIMALS = 6;
